import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {NoticeData, NoticeState} from '../type';

export const noticeSlice = createSlice({
  name: 'notice',
  initialState: {
    noticeData: undefined,
    noticeId: undefined,
    noticePage: undefined,
  } as NoticeState,
  reducers: {
    setNotice: (state, action: PayloadAction<NoticeData>): void => {
      state.noticeData = action.payload;
    },
    setNoticeId: (state, action: PayloadAction<string | undefined>): void => {
      state.noticeId = action.payload;
    },
    setNoticePage: (state, action: PayloadAction<number | undefined>): void => {
      state.noticePage = action.payload;
    },
  },
});

export const {setNotice, setNoticeId, setNoticePage} = noticeSlice.actions;
